import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { WidgetView } from '../widget/views';
import { isPhone, type SiteChatController } from './controller';

/** The live widget on the visitor's page. */
export function SiteChatApp({ controller, win }: { controller: SiteChatController; win: Window }) {
    const model = useSyncExternalStore(controller.subscribe, controller.getModel);
    const [phone, setPhone] = useState(() => isPhone(win));
    const [viewportHeight, setViewportHeight] = useState<number | null>(null);

    useEffect(() => {
        const query = win.matchMedia?.('(max-width: 759px)');
        if (!query)
            return;
        const update = () => setPhone(query.matches);
        query.addEventListener?.('change', update);
        return () => query.removeEventListener?.('change', update);
    }, [win]);

    // On a phone the open panel follows the visual viewport, so the keyboard shrinks the panel instead of
    // covering the composer.
    useEffect(() => {
        const viewport = win.visualViewport;
        if (!phone || !model.open || !viewport) {
            setViewportHeight(null);
            return;
        }
        const update = () => setViewportHeight(Math.round(viewport.height));
        update();
        viewport.addEventListener('resize', update);
        return () => viewport.removeEventListener('resize', update);
    }, [win, phone, model.open]);

    if (!controller.visible)
        return null;

    return <WidgetView model={model} frame="page" phone={phone} viewportHeight={viewportHeight} />;
}
